const mutations = {
  SET_SHOW_LOADER(state: any, payload: any) {
    state.showLoader = payload;
  }
};

export default mutations;
